var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-bandeau pt-1 pb-1"},[_c('span',[_vm._v("Livraison offerte en France métropolitaine dès 500€ d'achat")])])}]

export { render, staticRenderFns }